import { render, staticRenderFns } from "./CumulativeCostTable.vue?vue&type=template&id=9ae34b0e&scoped=true"
import script from "./CumulativeCostTable.vue?vue&type=script&lang=ts"
export * from "./CumulativeCostTable.vue?vue&type=script&lang=ts"
import style0 from "./CumulativeCostTable.vue?vue&type=style&index=0&id=9ae34b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae34b0e",
  null
  
)

export default component.exports